import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the setPassword state domain
 */

const selectSetPasswordDomain = (state) =>
  state.get("setPassword", initialState)

/**
 * Other specific selectors
 */
export const makeSelectValidateCode = () =>
  createSelector(selectSetPasswordDomain, (state) => state.get("validateCode"))

export const makeSelectIsLoadingValidateCode = () =>
  createSelector(selectSetPasswordDomain, (state) =>
    state.get("isLoadingValidateCode")
  )

export const makeSelectSetPassCorrect = () =>
  createSelector(selectSetPasswordDomain, (state) =>
    state.get("setPassCorrect")
  )

export const makeSelectIsLoadingSetPassCorrect = () =>
  createSelector(selectSetPasswordDomain, (state) =>
    state.get("isLoadingSetPassCorrect")
  )
/**
 * Default selector used by SetPassword
 */

const makeSelectSetPassword = () =>
  createSelector(selectSetPasswordDomain, (substate) => substate.toJS())

export default makeSelectSetPassword
export { selectSetPasswordDomain }
